import request from "@/utils/request"

// 获取异常订单信息信息
export function GetErrorOrderPageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/ErrorOrder/GetErrorOrderPageList",
    method: "post",
    data
  })
}
